"use client";

import React from "react";

export const SidebarSectionLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="text-caption font-semibold text-cede-text-secondary/70">{children}</div>
);
